import { FormControl, FormHelperText } from '@material-ui/core';
import React from 'react';
import useStyles from '../../MUIClasses/useStyles';
import CustomAlert from '../CustomAlert';
import { supportedImagesArray } from '../../Constants';

const BannerInput = ({ handleFileChange, bannerFile }) => {
    return (
        <FormControl
            variant="outlined"
            className={useStyles().formControl}
        >
            <input accept=".png,.jpg,.jpeg"
                type="file"
                name="bannerFile"
                onChange={handleFileChange}
                placeholder="Selecione seu arquivo"
            />
            {
                bannerFile && (
                    <CustomAlert
                        severity="success"
                        message="Arquivo carregado com sucesso!"
                    />
                )
            }
            <FormHelperText id="my-helper-text">Arquivo em {supportedImagesArray.toString()}</FormHelperText>
            <CustomAlert message="AVISO: Arquivo fora da formatação do modelo OU da extensão serão serão apresentados" />
        </FormControl>
    );
}

export default BannerInput;
